import React from 'react'
import * as S from './styles'
import { colors } from '@shared/interfaces/Colors'
import { tagTheme, Typography } from '@taglivros/tag-components'
import TagRibbon from '@site/components/atoms/TagRibbon'
import { Page } from '@shared/interfaces/Pages'

const HowItWorksHeader = ( { title, subtitle, color, page } : HowItWorksHeader.Props ): React.ReactElement => {
  const flag = page === 'curadoria' ? '#21C5E5' : '#FFA435'

  return (
    <>
      <S.Container
        className="how-it-works-header"
        $color={ colors[ page ].SELECTED! }
        $border={ colors[ page ].PRIMARY! }
        $page={ page }
      >
        <S.WrapperHeader
          $page={ page }
          className="how-it-works-header__wrapper-header"
        >
          {page !== 'home' && (
            <TagRibbon
              color={ flag }
            />
          )}
          <Typography
            color={ color }
            as="p"
            fontFamily="notoSans"
            fontWeight="xs"
            fontSizeMobile="xs"
            fontSizeDesktop="s"
            variant="customText"
          >
            { title }
          </Typography>
          <Typography
            color={ color }
            as="h2"
            fontFamily="robotoSlab"
            fontWeight="xs"
            fontSizeMobile="title-p"
            fontSizeDesktop="title-m"
            variant="customText"
          >
            { subtitle.map( ( text, index ) => {
              const key = String( index )
              return ( ( index === 1 || index === 3 ) ?
                <S.Highlight
                  className="how-it-works-header__highlight"
                  key={ key }
                >
                  { text }
                </S.Highlight> :
                <React.Fragment key={ key }>{ text }</React.Fragment> )
            } ) }
          </Typography>
        </S.WrapperHeader>
      </S.Container>
      {page !== 'home' && (
        <S.Wave
          className="how-it-works-header__wave"
          $color={ colors[ page ].SELECTED! }
        />
      )}

    </>
  )
}

namespace HowItWorksHeader {
  export interface Props {
    title: string
    subtitle: string[]
    color: keyof typeof tagTheme.cores
    page: Page
  }
}

export default HowItWorksHeader
